export const WS_RETURN_URL_KEY = "wsReturnUrl";

// If the user abandons the Okta flow, a stored return url must not survive
// long enough to hijack a later direct visit to the CMS in the same tab
const WS_RETURN_URL_TTL_MS = 2 * 60 * 1000;

export const isEmbeddedInWorkspace = () => {
  try {
    return window !== window.parent;
  } catch (e) {
    return true;
  }
};

// Okta cannot complete a login inside a cross-origin iframe (frame-ancestors
// blocks its pages and the session cookie is third-party), so the workspace
// must run the flow on the top-level window
export const notifyWorkspaceLoginRequired = () => {
  window.parent.postMessage(
    JSON.stringify({ type: "AUTH_STATE_CHANGED", needsLogin: true }),
    process.env.REACT_APP_PARENT_ORIGIN || "*",
  );
};

// The query param is lost during the Okta redirects, so it is persisted in
// sessionStorage before the flow starts
export const saveWorkspaceReturnUrl = () => {
  const wsReturnUrl = new URLSearchParams(window.location.search).get(WS_RETURN_URL_KEY);

  if (!wsReturnUrl) return;

  sessionStorage.setItem(WS_RETURN_URL_KEY, JSON.stringify({ url: wsReturnUrl, ts: Date.now() }));
};

export const consumeWorkspaceReturnUrl = (): string | null => {
  const stored = sessionStorage.getItem(WS_RETURN_URL_KEY);

  if (!stored) return null;

  sessionStorage.removeItem(WS_RETURN_URL_KEY);

  let parsed: { url?: string; ts?: number };
  try {
    parsed = JSON.parse(stored);
  } catch (e) {
    return null;
  }

  if (!parsed?.url || !parsed.ts || Date.now() - parsed.ts > WS_RETURN_URL_TTL_MS) return null;

  // Only redirect back to the configured workspace origin (open redirect guard)
  const parentOrigin = process.env.REACT_APP_PARENT_ORIGIN;
  if (parentOrigin && parentOrigin !== "*") {
    try {
      if (new URL(parsed.url).origin !== new URL(parentOrigin).origin) return null;
    } catch (e) {
      return null;
    }
  }

  return parsed.url;
};
